import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class CompactProductRowStyle {
    static getStyle(options) {
        const { theme } = options;
        const { spacing, color } = theme;
        return css `
			${Text.CSS}

			p {
				margin: 0;
			}

			kompis-price-formatter,
			skapa-product-identifier,
			p {
				font-size: ${10 / 16}rem !important;
				color: ${color.text.dark};
			}

			.visuallyHidden {
				border: 0 !important;
				clip: rect(${1 / 16}rem, ${1 / 16}rem, ${1 / 16}rem, ${1 / 16}rem) !important;
				-webkit-clip-path: inset(50%) !important;
				clip-path: inset(50%) !important;
				height: ${1 / 16}rem !important;
				margin: -${1 / 16}rem !important;
				overflow: hidden !important;
				padding: 0 !important;
				position: absolute !important;
				width: ${1 / 16}rem !important;
				white-space: nowrap !important;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				-webkit-user-select: none;
				user-select: none;
			}
			.compactPrice,
			.quantity p {
				color: ${color.text.dark};
			}

			.selfServeLocationContainer {
				display: flex;
			}

			.locationText {
				margin: 0;
				font-weight: bold;
				margin-top: ${3 / 20}rem;
				color: ${color.text.dark};
			}

			.productIdentifiers {
				display: flex;
			}

			.productIdentifierDivider {
				width: ${spacing.space75 / 16}rem;
				flex-shrink: 0;
			}

			.compactWrapper {
				display: grid;
				/* This style is the same as in product list, to make the grid match the product list headers. */
				grid-template-columns: ${30 / 16}rem 1fr ${83 / 16}rem ${86 / 16}rem ${60 / 16}rem ${80 /
            16}rem ${80 / 16}rem;
				gap: 0 ${spacing.space75 / 16}rem;
				align-items: center;
				font-size: ${12 / 16}rem;
			}

			.weight {
				color: ${color.text.dark};
			}
			.compactPriceWrapper:last-of-type {
				text-align: end;
			}
			kompis-price-formatter:last-of-type {
				display: inline-block;
				justify-self: end;
			}
			.compactCommercialMessage,
			.productName {
				color: ${color.text.dark};
				font-weight: bold;
			}

			.productDescription {
				color: ${color.text.dark};
			}

			.lowInStockStoreStatus {
				margin-top: ${spacing.space25 / 16}rem;
			}

			.lowInStockStoreStatus svg {
				margin-right: ${spacing.space50 / 16}rem;
			}

			.quantity {
				font-weight: unset;
			}
		`;
    }
}
//# sourceMappingURL=CompactProductRowStyle.js.map